import { useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { selectedInsuranceProductIndices, selectedInsuranceProducts } from "state/planSetup";
import { useNavigate } from "react-router";
import routes from "components/routes";

const useNavigateInsuranceSetup = () => {
  const navigate = useNavigate();
  // selected products indices
  const [selectedProducts] = useRecoilState(selectedInsuranceProductIndices);
  const selectedSetupPlan= useRecoilValue(selectedInsuranceProducts);

  // check whether given product index is eligible for navigation
  const checkIfProductExist = (index) => {
    let completed_products = localStorage.getItem("marked_products");
    let parsed = JSON.parse(completed_products) || [];
    // check the given index is in selected products
    const isSelected = selectedProducts.some(
      (productIndex) => productIndex === index
    );
    // check the given index is not in completed setup products
    const isCompleted = parsed.some((productIndex) => productIndex === index);

    return isSelected && !isCompleted;
  };

  useEffect(() => {
    if (selectedProducts.length) {
      // navigating to next possible setup page if selected products are present
      navigateInsurancePlan();
    } else {
      // navigate to base insurance setup page
      navigate(`/${routes.INSURANCE_SETUP}`);
    }
  }, [selectedProducts]);

  const navigateInsurancePlan = () => {
    // completed marked products
    const completed = localStorage.getItem("marked_products");
    const gmcSetup = localStorage.getItem('gmc_done')
    if(gmcSetup){
      if(gmcSetup === 'TPA'){
        navigate(`/${routes.GHI_TPA_SETUP}`);
        return
      } else{
        navigate(`/${routes.GMC_RATECHART}`)
        return
      }
    }
    if (checkIfProductExist(0)) {
      // navigating to gmc setup page
      navigate(`/${routes.GMC_SETUP}`);
    } else if (checkIfProductExist(1)) {
      // navigating to gpa setup page with type as GPA
      navigate(`/${routes.GPA_SETUP}`, {
        state: { type: "GPA" },
      });
    } else if (checkIfProductExist(2)) {
      // navigating to gtl setup page with type as GTL
      navigate(`/${routes.GTL_SETUP}`, {
        state: { type: "GTL" },
      });
    } else if (selectedProducts.length === (completed && JSON.parse(completed).length)) {
      // navigate to documents upload
      localStorage.setItem('selected_plan_document', JSON.stringify(selectedSetupPlan));
      navigate(`/${routes.SELECT_PLAN}`);
    }
  };

  // returning the hook method to be called from component
  return { navigateInsurancePlan, checkIfProductExist };
};

export default useNavigateInsuranceSetup;
